const PARAMS_STORAGE_LAST_CONFIG = 'lastConfig'

export const getLastConfig = () => {
  if (typeof localStorage === 'undefined') {
    return null
  }

  return JSON.parse(window.localStorage.getItem(PARAMS_STORAGE_LAST_CONFIG))
}

export const saveLastConfig = parameters => {
  if (typeof localStorage === 'undefined') {
    return
  }

  window.localStorage.setItem(PARAMS_STORAGE_LAST_CONFIG, JSON.stringify(parameters))
}

export const resetLastConfig = () => {
  if (typeof localStorage === 'undefined') {
    return
  }

  window.localStorage.removeItem(PARAMS_STORAGE_LAST_CONFIG)
}

export default { getLastConfig, saveLastConfig, resetLastConfig }
